import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const taxonomiesManifest: FeatureManifest = {
  id: 'english-knowledge-taxonomies',
  path: 'english-knowledge/vocabularies/taxonomies/*',
  navPath: '/english-knowledge/vocabularies/taxonomies',
  label: 'Phân loại',
  description: 'Quản lý taxonomy và term thuộc feature từ vựng',
  navigationGroup: {
    id: 'vocabulary',
    label: 'Từ vựng',
  },
  load: () => import('./entry'),
}
